/**
 * Single source of truth for 4in × 6.75in thermal packing-slip / label print sizing.
 * SCSS: mirror in printPackingSlipPeel.scss as CSS variables (--thermal-page-*).
 */

import type { CSSProperties } from 'react';

/** Page width in inches (TS math / pagination). */
export const THERMAL_PAGE_WIDTH_IN = 4;

/** Total page height in inches (matches @page and slip box). */
export const THERMAL_PAGE_HEIGHT_IN = 6.75;

/** Bottom peel strip reserved height in inches (barcode zone). */
export const THERMAL_PEEL_STRIP_IN = 0.75;

/** CSS length strings for inline styles and injected @page. */
export const THERMAL_PAGE_WIDTH_CSS = `${THERMAL_PAGE_WIDTH_IN}in`;
export const THERMAL_PAGE_HEIGHT_CSS = `${THERMAL_PAGE_HEIGHT_IN}in`;

/** classList token on document.documentElement for thermal print layout SCSS. */
export const PRINT_PACKING_SLIP_PEEL_HTML_CLASS = 'print-packing-slip-peel';

/** CSS pixel density for print pagination (browser layout). */
export const PX_PER_INCH = 96;

/** Sales channels that use the FitCrunch packing slip template (PaginatedPackingSlipOrder). */
export const FIT_CRUNCH_SALES_CHANNEL_IDS = new Set([
    43, 46, 47, 82, 83, 84, 85, 147,
]);

/** Black “Packing Slip” banner row (FitCrunch default slip header variant). */
export const FIT_CRUNCH_BLACK_BANNER_SALES_CHANNEL_IDS: readonly number[] = [43, 46, 47, 82];

/** Alternate header table block (FitCrunch). */
export const FIT_CRUNCH_ALT_HEADER_SALES_CHANNEL_IDS: readonly number[] = [83, 84, 85];

export function isFitCrunchSalesChannel(salesChannelId: number | undefined): boolean {
    return salesChannelId != null && FIT_CRUNCH_SALES_CHANNEL_IDS.has(salesChannelId);
}

/** Busy state placeholder: matches thermal slip dimensions. */
export function getThermalBusyPlaceholderStyle(): CSSProperties {
    return {
        width: THERMAL_PAGE_WIDTH_CSS,
        minHeight: THERMAL_PAGE_HEIGHT_CSS,
        height: THERMAL_PAGE_HEIGHT_CSS,
    };
}
